import { BoneModal } from './BoneModal';

export function initFilterAndSortModals() {
	const filterSidebar = document.getElementById('filter-sidebar');
	const sortSidebar = document.getElementById('sort-sidebar');

	if (filterSidebar) {
		new BoneModal(filterSidebar);
	}


	if (sortSidebar) {
		new BoneModal(sortSidebar);
	}
}



export function unloadFilterAndSortModals() {
	const filterSidebar = document.getElementById('filter-sidebar');
	const sortSidebar = document.getElementById('sort-sidebar');

	if (filterSidebar && filterSidebar.BoneModal) {
		filterSidebar.BoneModal.destroy();
	}

	if (sortSidebar && sortSidebar.BoneModal) {
		sortSidebar.BoneModal.destroy();
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/filter-and-sort.js